export default "__VITE_ASSET__BUlSGsqK__"